//
//
//
//
//
//
import buttonBase from './_buttonBase';
export default {
  extends: buttonBase,
  methods: {
    performAction: function performAction() {
      if (this.$_checkForprivacyOptOut(this.button) == true) {
        return;
      }

      if (!this.button) {
        if (GeneralMills.debugMode) {
          console.log("[Social Button] button does not exist");
        }

        return;
      }

      if (!this.button.providerName) {
        if (GeneralMills.debugMode) {
          console.log("[Social Button] Social network provider name missing or invalid");
        }

        return;
      }

      if (!this.button.shareUrlFormat) {
        if (GeneralMills.debugMode) {
          console.log("[Social Button] Social network share url format missing or invalid");
        }

        return;
      }

      if (!this.pageAttributes) {
        if (GeneralMills.debugMode) {
          console.log("[Social Button] pageAttributes does not exist");
        }

        return;
      }

      var url = this.pageAttributes['url'],
          providerNamePassedToEvents = this.button.providerNamePassedToEvents;

      if (!url) {
        if (GeneralMills.debugMode) {
          console.log("[Social Button] url attribute value was not found [url: " + url + "]");
        }

        return;
      }

      var shareURL = this.button.shareUrlFormat.replace('{0}', decodeURIComponent(url));
      this.$_openShareWindow(shareURL, this.button.providerName); // Raise analytics event

      var eventType = "SocialShare";
      var analyticsEventParams = {
        SocialNetwork: providerNamePassedToEvents
      };
      this.$_raiseAnalyticsEvent(eventType, analyticsEventParams);
      return true;
    },
    $_openShareWindow: function $_openShareWindow(shareURL, providerName) {
      var width = 600,
          height = 800;

      if (providerName == 'pinterest') {
        width = 800;
      }

      var left = screen.width / 2 - width / 2,
          top = screen.height / 2 - height / 2;
      return window.open(shareURL, '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
    }
  }
};